module.exports = __webpack_public_path__ + "img/cloud-security.717bdf1.svg";